"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentConfigOutSerializer = void 0;
exports.SegmentConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=segmentConfigOut.js.map